import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ORSuites from './components/ORSuites';

const oRSuites = (props,{ t }) => (
  <Container>
    <ORSuites {...props} />
  </Container>
);

oRSuites.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(oRSuites);
